import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import BlocoErro from '../../../shared/listaerros/BlocoErro.js';
import {criarColunaOpcoes} from '../ColunaOpcoes.jsx';
import {PAGINACAO_PADRAO} from '../paginacao.js';
import {buttonTableCell} from '../../../../utils/styles.js';

const TABLE_CONTAINER_PROPS = {component: 'div'};

const useStyles = makeStyles(theme => ({
    ...buttonTableCell(theme)
}));

/*
 * Lista do formulário de Processo de Seleção (cursos, ENEMs, processos
 * vestibulares): DataGrid com o botão da toolbar, a coluna Opções montada a
 * partir de `acoes(linha, posicao)` e o erro do campo `nome` em volta.
 */
export default function TabelaProcesso({nome, errors, linhas = [], colunas, acoes, botao, semRegistros}) {
    const classes = useStyles();
    const erro = errors[nome];

    return (
        <Grid item xs={12}>
            <BlocoErro erro={!!erro} itens={erro ? [erro.message] : []}>
                <DataGrid
                    toolbarContent={botao}
                    tableContainerProps={TABLE_CONTAINER_PROPS}
                    rows={linhas}
                    paginate
                    paginateOptions={PAGINACAO_PADRAO}
                    noRecordsText={semRegistros}
                    columns={[
                        ...colunas,
                        criarColunaOpcoes(row => acoes(row, linhas.indexOf(row)), {className: classes.buttonTableCell})
                    ]}/>
            </BlocoErro>
        </Grid>
    );
}

TabelaProcesso.propTypes = {
    /* Campo do formulário (para mostrar o erro dele). */
    nome: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired,
    linhas: PropTypes.array,
    colunas: PropTypes.array.isRequired,
    /* (linha, posicao) => [{titulo, icone, onClick}] da coluna Opções. */
    acoes: PropTypes.func.isRequired,
    botao: PropTypes.node,
    semRegistros: PropTypes.string
};
